<template>
    <div class="body-padding user">
        <div class="user-header">
            <div class="user-info">
                <div class="user-info-avatar" :style="{backgroundImage: 'url(' + src + ')'}"></div>
                <div class="user-info-container">
                    <div class="user-info-nickname text-main">{{userName}}</div>
                    <div class="user-info-address text-info">{{districtName}}</div>
                    <div class="user-info-number text-info">会员号：{{memberNumber}}</div>
                </div>
                <div class="user-info-setting">
                    <span class="icon-setting-wrap">
                        <!-- <span class="icon icon-message"><span class="news">2</span></span> -->
                        <!-- <span class="icon icon-setting"></span> -->
                    </span>
                    <span class="icon-setting-wrap">
                        <span class="icon"></span>
                        <span class="icon"></span>
                    </span>
                    <span class="vip-flag">会员</span>
                </div>
            </div>
            <!--<div class="user-order">
                <div class="user-order-item"><span class="user-order-item__count">0</span><span class="user-order-item__label">我寄的</span></div>
                <div class="user-order-item"><span class="user-order-item__count">0</span><span class="user-order-item__label">我收的</span></div>
                <div class="user-order-item"><span class="user-order-item__count">0</span><span class="user-order-item__label">我的积分</span></div>
            </div>-->
        </div>
        <div class="user-body">
            <!--<router-link tag="div" to="/" class="user-body-link">地址管理</router-link>-->
            <!--<router-link tag="div" to="/" class="user-body-link">在线客服</router-link>-->
            <div @click="handleModifyPassword" class="user-body-link">修改密码</div>
<!--            <van-cell is-link @click="handleWeChatBinding" v-show="!$store.state.openid">微信绑定</van-cell>-->
            <van-popup v-model="isWeChatBinding" style="border-radius: 5px">
                <div class="weChat_binding">
                    <input type="text" placeholder="请输入手机号码" class="weChat_binding_input" v-model="value">
                    <div class="weChat_binding_btn">
                        <span style="background-color: rgb(152, 143, 143)" @click="isWeChatBinding=false">取消</span>
                        <span style="background-color: #1aad19" @click="handleConfirm">确定</span>
                    </div>
                </div>
            </van-popup>
            <router-link tag="div" to="/order/myorder" class="user-body-link">我的订单</router-link>
            <router-link tag="div" to="/myCoupon" class="user-body-link">我的优惠券</router-link>
            <router-link tag="div" to="/user/inviteEnroll" class="user-body-link">邀请注册</router-link>
            <!--<router-link tag="div" to="/" class="user-body-link">意见反馈</router-link>-->
<!--            <div @click="handleModifyNickname" class="user-body-link">修改昵称</div>-->
            <div class="btn-wrap">
                <van-button type="warning" round @click="handleLogout">退出登录</van-button>
            </div>
        </div>
        <change-password v-model="modifyPassword"></change-password>
        <modify-nickname v-model="modifyNickname" @success="handleNicknameSuccess"></modify-nickname>
    </div>
</template>

<script>
    export default {
        name: "User",
        data() {
            return {
                modifyPassword: false,
                modifyNickname: false,
                isWeChatBinding: false,
                src: '',
                districtName: '',
                userName: '',
                memberNumber: '',
                value: '',
            }
        },
        components: {
            ChangePassword: () => import('./components/ModifyPassword'),
            ModifyNickname: () => import('./components/ModifyNickname')
        },
        methods: {
            /*微信绑定功能*/
            handleConfirm() {
                let params = {
                    params: {
                        mobile: this.$store.state.mobile,
                        openId: this.value,
                        wechatMark: this.$wechatMark
                    }
                }
                this.$axios.post('weixin/update/openid',params)
            },
            handleWeChatBinding() {
                this.isWeChatBinding = true
            },
            handleModifyPassword() {
                this.modifyPassword = true
            },
            handleModifyNickname() {
                this.modifyNickname = true
            },
            handleLogout() {
                this.$store.commit('logout')
                // this.$router.go({
                //     name: 'Login'
                // })
                this.$router.push('user/login')
            },
            handleNicknameSuccess() {
                this.modifyNickname = false
                this.getUserInfo()
            },
            getUserInfo() {
                this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    duration: 0,
                    mask: true
                })
                let params = {
                    params: {
                        mobile: this.$store.state.mobile,
                        loginType: 5
                    }
                }
                this.$axios.post('user/getUserInfo', params).then(res => {
                    let data = res.data.data
                    if (data.photo) {
                        this.src = data.photo
                    }
                    this.districtName = data.districtName
                    this.userName = data.nickname
                    this.memberNumber = data.memberNumber
                    this.$toast.clear()
                }).catch(err => {
                    this.$toast.clear()
                    this.$toast({
                        message: err.data.msg,
                        duration: 1000
                    })
                })
            }
        },
        mounted() {
            this.getUserInfo()
        }
    }
</script>

<style scoped lang="scss">
    .text-main {
        color: #2F2F2F;
        font-size: 0.48rem;
    }

    .text-info {
        color: #8F8F8F;
        font-size: 0.32rem;
    }

    .user {
        display: flex;
        flex-direction: column;
    }

    /************************头部****************************/
    .user-header {
        background: #ffffff;
        padding: 0.31rem;
    }

    .user-info {
        height: 1.44rem;
        display: flex;
        flex-direction: row;

        &-avatar {
            border-radius: 50%;
            height: 1.44rem;
            width: 1.44rem;
            background-color: #CBCBCB;
            margin-right: 0.27rem;
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
        }

        &-container {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    .user-info-setting {
        display: flex;
        flex-direction: column;

        .icon-setting-wrap {
            margin-bottom: 0.24rem;

            .icon {
                display: inline-block;
                width: 0.53rem;
                height: 0.53rem;

                &-message {
                    background: url('../../assets/concat.png') center / 100% no-repeat;
                    position: relative;
                }

                &-setting {
                    background: url('../../assets/icon-setting.png') center / 100% no-repeat;
                }

                & ~ .icon {
                    margin-left: 0.31rem;
                }
            }
        }

        .vip-flag {
            vertical-align: middle;
            position: relative;
            right: -0.31rem;
            background-color: #FE9329;
            color: #fff;
            height: 0.48rem;
            line-height: 0.48rem;
            width: 1.37rem;
            font-size: 0.32rem;
            text-align: center;
            border-radius: 0.48rem 0 0 0.48rem / 0.48rem;
            top: -0.8rem;
        }
    }

    .user-order {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-top: 0.28rem;

        &-item {
            flex: 1;
            display: flex;
            flex-direction: column;
            color: #4F4F4F;
            text-align: center;
            overflow: hidden;

            &__count {
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                font-size: 0.48rem;
            }

            &__label {
                font-size: 0.4rem;
            }
        }
    }

    /************************链接************************/
    .user-body {
        margin-top: 0.13rem;
        background: #ffffff;
        flex: 1;

        .user-body-link {
            height: 1.33rem;
            line-height: 1.33rem;
            padding: 0 0.31rem;
            font-size: 0.4rem;
            color: #4F4F4F;
            border-bottom: 1px solid #e5e5e5;
            position: relative;
            transition: background 100ms;

            &::after {
                position: absolute;
                right: 0.31rem;
                top: 50%;
                transform: translateY(-50%);
                content: '';
                width: 0.21rem;
                height: 0.39rem;
                background: url('../../assets/arrow-line.png') center / 100% no-repeat;
            }

            &:active {
                background: #f2f3f5;
            }
        }

        .btn-wrap {
            text-align: center;
            margin-top: 1.04rem;

            .van-button {
                height: 0.96rem;
                line-height: 0.96rem;
                width: 95%;
            }
        }
    }

    .news {
        position: absolute;
        width: 0.4rem;
        height: 0.4rem;
        background-color: rgb(254, 147, 41);
        border-radius: 50%;
        text-align: center;
        line-height: .4rem;
        color: #fff;
        left: 0.4rem;
        top: -0.133333rem;
    }

    .weChat_binding {
        width: 8rem;
        height: 5rem;
    }

    .weChat_binding_input {
        width: 5rem;
        height: 1rem;
        margin: 1rem;
        border: 1px solid #ccc;
        padding: 0 .5rem;
        line-height: 1rem;
        font-size: 0.43rem;
        letter-spacing: 2px;
    }

    .weChat_binding_btn {
        padding: 0 1rem;
        height: 1rem;

        span {
            display: inline-block;
            width: 50%;
            box-sizing: border-box;
            font-size: 0.53rem;
            text-align: center;
            line-height: 1rem;
            color: #fff;
        }
    }
</style>
